{
  "FormEngineSignalWfl": {
    "title": "Signal",
    "description": "Lösen Sie Signale aus Ihrem Formular aus, um einen Workflow zu starten"
  },
  "mask": {
    "FormEngineSignalWfl": {
      "groupTitle": "Signal",
      "signalType": "Signal Typ",
      "signalOnChangeSource": "Auslösendes Feld",
      "options": {
        "default": "Manuell ausgelöst",
        "onFieldChange": "Bei Feldänderung"
      }
    }
  }
}